import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Container, Card, Alert } from 'react-bootstrap';
import { Capacitor } from '@capacitor/core';
import Header from '../components/Header';
import TabBar from '../components/TabBar';

const TestPages: React.FC = () => {
  const navigate = useNavigate();

  const testPages = [
    { name: 'Borç Ödeme', route: '/odeme', description: 'Payment sayfasını test et' },
    { name: 'Şoförlerim', route: '/soforlerim', description: 'Soforlerim sayfasını test et' },
    { name: 'Plaka Listesi', route: '/plaka-listesi', description: 'Plaka listesi sayfasını test et' },
    { name: 'Tahsilatlar', route: '/tahsilatlar', description: 'Tahsilatlar sayfasını test et' }
  ];

  return (
    <div className="page-container">
      <Header title="Test Sayfaları" />
      <div className="page-content" style={{ padding: '20px' }}>
        <Container>
          <Alert variant="info">
            <Alert.Heading>Platform Bilgileri</Alert.Heading>
            <p>
              <strong>Platform:</strong> {Capacitor.getPlatform()}<br/>
              <strong>Native App:</strong> {Capacitor.isNativePlatform() ? 'Evet' : 'Hayır'}<br/>
              <strong>Web App:</strong> {!Capacitor.isNativePlatform() ? 'Evet' : 'Hayır'}
            </p>
          </Alert>
          
          <h2>Sayfa Testleri</h2>
          <p>Aşağıdaki butonlara tıklayarak sayfaların açılıp açılmadığını test edin:</p>
          
          <div className="row">
            {testPages.map((page, index) => (
              <div key={index} className="col-md-6 mb-3">
                <Card>
                  <Card.Body>
                    <Card.Title>{page.name}</Card.Title>
                    <Card.Text>{page.description}</Card.Text>
                    <Button 
                      variant="primary" 
                      onClick={() => {
                        console.log(`${page.name} sayfasına yönlendiriliyor: ${page.route}`);
                        navigate(page.route);
                      }}
                    >
                      {page.name} Sayfasını Aç
                    </Button>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
          
          <div className="mt-4">
            <h4>Kullanıcı Bilgileri (localStorage)</h4>
            <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '5px', fontSize: '12px' }}>
              {JSON.stringify({
                userInfo: localStorage.getItem('userInfo'),
                isAuthenticated: localStorage.getItem('isAuthenticated'),
                sessionUserInfo: sessionStorage.getItem('userInfo'),
                allLocalStorageKeys: Object.keys(localStorage),
                allSessionStorageKeys: Object.keys(sessionStorage)
              }, null, 2)}
            </pre>
          </div>
          
          <div className="mt-4">
            <h4>Authentication Test</h4>
            <Button 
              variant="success" 
              onClick={() => {
                // Test için auth bilgilerini ayarla
                const testUser = {
                  uyeid: '123',
                  isim: 'Test User',
                  telefon: '5551234567'
                };
                localStorage.setItem('userInfo', JSON.stringify(testUser));
                localStorage.setItem('isAuthenticated', 'true');
                console.log('Test auth bilgileri ayarlandı');
                window.location.reload();
              }}
              className="me-2"
            >
              Test Auth Ayarla
            </Button>
            
            <Button 
              variant="danger" 
              onClick={() => {
                localStorage.clear();
                sessionStorage.clear();
                console.log('Tüm storage temizlendi');
                window.location.reload();
              }}
            >
              Storage Temizle
            </Button>
          </div>
        </Container>
      </div>
      <TabBar />
    </div>
  );
};

export default TestPages; 